module.exports = __webpack_public_path__ + "static/media/collect-points@2x.f9efe6d2.png";